var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7049 0.509646C13.2888 0.0930076 12.6131 0.0932703 12.1965 0.509646L5.40776 7.29865L2.39045 4.28137C1.97382 3.86474 1.29845 3.86474 0.881815 4.28137C0.465176 4.69801 0.465176 5.37337 0.881815 5.79001L4.65328 9.56148C4.86147 9.76967 5.13445 9.87402 5.40747 9.87402C5.68048 9.87402 5.95373 9.76993 6.16192 9.56148L13.7049 2.01826C14.1215 1.60191 14.1215 0.926258 13.7049 0.509646Z",
    fill: "#f4694b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTick);
export default __webpack_public_path__ + "static/media/OrangeTick.1473d8cf6e1cf7e053a814eaf415bb0c.svg";
export { ForwardRef as ReactComponent };